export { OurCommitmentFeature } from './lib/our-commitment'
export type { OurCommitmentStoryContent } from './lib/types/our-commitment-page'

export type { OurCommitmentFeatureProps } from './lib/get-static-props'
export { getStaticProps } from './lib/get-static-props'
